const initialState = { contents: [],searchList:[], contentDetail: null };

export default (state = initialState, action) => {
  const type = action && action.type;
  switch (type) {
    case 'SET_CONTENT':
      return { ...state, contents: action.data };
      case 'SET_SEARCH_CONTENT':
      return { ...state, searchList: action.data };  
      case 'SET_SEARCH_CONTENT_EMPTY':
      return { ...state, searchList: [] };  
    case 'SET_SELECTED_CONTENT':
      return { ...state, contentDetail: action.data };
    default:
      return state;
  }
};
